export enum USER_ROLES {
  ADMIN_USER = 'Admin User',
  REGULAR_USER = 'Regular User',
  REGIONAL_TECH_SUPPORT = 'Regional Tech Support/Case Owner'
}
